import { Suspense } from "react";
import { useParams, Navigate } from "react-router-dom";
import { toolRegistry } from "../lib/toolRegistry";

export default function ToolPage() {
  const { slug } = useParams<{ slug: string }>();
  const Component = slug ? toolRegistry[slug] : undefined;

  if (!Component) {
    return <Navigate to="/" replace />;
  }

  return (
    <Suspense fallback={<div className="text-center py-20 text-gray-400">Đang tải...</div>}>
      <Component />
    </Suspense>
  );
}
